// extracted by mini-css-extract-plugin
module.exports = {"container":"dzH0x___Amenities-module__container","amenity-row":"_2dCuA___Amenities-module__amenity-row"};